import React from "react"; 

export function CustomSvg({color, className}) {
  return (
    <svg className={className} width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="17.8994" y1="9.44189" x2="1.89941" y2="9.44189" stroke={`${color}`} stroke-width="2" stroke-linecap="round"/>
      <line x1="10.1851" y1="17.728" x2="10.1851" y2="1.72803" stroke={`${color}`} stroke-width="2" stroke-linecap="round"/>
    </svg>
  )
}
